/**
 * 每日用户活跃统计组件
 * zxw
 * 创建时间：2025-12-10
 */

import { useEffect } from 'react';
import { Chart } from '@antv/g2';
import { Skeleton } from 'antd';
import CNF from '../../../incs/Config.js';
import { isMobileDevice } from '../../../incs/FunHelper.js';

const ChartLineUTACD = props => {
    const { children, id, title, subtitle, streamStatus } = props;

    const timestamp = new Date().getTime().toString();
    const chartId = `${id ? id : 'antv-g2-id'}.${timestamp}`;

    // 加载中显示默认图片
    if (streamStatus === 'loading') {
        return <Skeleton.Image active={true} />;
    }

    useEffect(() => {
        const chart = new Chart({
            container: chartId,
            autoFit: isMobileDevice,
        });

        chart.title({
            title: title,
            subtitle: subtitle,
        });

        // 格式化数据
        chart.data(JSON.parse(children));

        chart
            .line()
            .encode('x', 'date')
            .encode('y', 'count')
            .encode('color', 'type')
            .encode('shape', 'smooth')
            .scale('y', { independent: true })
            .scale('y', { nice: true })
            .scale('color', {
                range: CNF.swatches[CNF.currentSwatche],
            })
            .axis('x', { title: '日期', })
            .axis('y', { title: '', labelFormatter: (d) => (d) })
            // .animate('enter', {
            //     type: 'pathIn',
            //     duration: 3000,
            // },)
            .tooltip({
                items: [
                    (d) => {
                        if (d.type === '登录人数') {
                            return { channel: 'y', value: `${d.count}个`, }
                        } else {
                            return { channel: 'y', value: `${d.count}次`, }
                        }
                    },
                ],
            })
            .style('lineWidth', 1);
        chart.render();

        return () => {
            chart.destroy();
        }
    }, [props]);

    return <div id={chartId}></div>
}

export default ChartLineUTACD;